module.exports = __webpack_public_path__ + "static/media/expand.2876c3c5.svg";